<div class="page-content nd-notification-details-main">
  
  <one-breadcrumbs>
    <one-breadcrumb-element *ngFor="let breadcrumb of breadcrumbs; last as isLast">
      <span *ngIf="!isLast" [routerLink]="['breadcrumb.url']" class="mat-caption" routerLinkActive="router-link-active">
        {{ breadcrumb.label }}
      </span>
      <span *ngIf="isLast" class="mat-small">
        {{ breadcrumb.label }}
      </span>
      <mat-icon>arrow_forward</mat-icon>
    </one-breadcrumb-element>
  </one-breadcrumbs>

  <p>{{notificationData.title}}</p>

  <div class="card-container" style="display:flex; width:100%; justify-content: space-between; margin:auto; padding:auto; overflow:hidden; flex-wrap: wrap;">

    <mat-card oneCard class="card-list" style="max-width:39.5%; width:100%">
      <mat-card-title>
        <div class="mat-title">General information</div>
      </mat-card-title>
      <mat-card-content style="display: block;overflow-x: auto;padding-top: 10px;">
        <div class="item">
          <div class="title">Status</div>
          <div class="chip-value">
            <mat-chip class="notification-list-source-chip truncate-text" oneChip oneChipAppearance="outline">
              <img src="assets/{{notificationStatusIcon}}" class="chip-icon">{{ notificationData.Status }}
            </mat-chip> 
            <div>
              <button *ngIf="userPermission.SendNotification && notificationData.Status !== 'Completed'" [matMenuTriggerFor]="exampleMenuLeft" [disabled]="notificationData.Status == 'Completed'" title="Click to update status" one-icon-button mat-icon-button>
                <i class="one-icons">more_vertical</i>
              </button>
              <mat-menu #exampleMenuLeft="matMenu" xPosition="before" yPosition="below" oneMenu>
                <button mat-menu-item (click)="openStatusDialog()">
                  <span>Set to "Complete"</span>
                </button>
                <button mat-menu-item (click)="openDueDateRemindersDialog()" [disabled]="notificationData.Status === 'Completed' || notificationData.Status === 'Overdue' || areAllAccountsFeedbackOverdue()">
                  <span>Due date and reminders</span>
                </button>
              </mat-menu>
            </div>           
          </div>
        </div>
        <div class="item" style="margin-top: 10px;">
          <div class="title">Creation date</div>  
          <div class="value truncate-text" [title]="notificationData.CreationDate">{{ appUtil.formatDateOnly(notificationData.CreationDate ) }}</div> 
        </div>
        <div class="item">
          <div class="title">Local ID</div>  
          <div class="value truncate-text" [title]="notificationData.LocalId">
            {{ notificationData.LocalId }}
          </div> 
        </div>
        <div class="item">
          <div class="title">Global ID</div>  
          <div class="value truncate-text" [title]="notificationData.GlobalId">
            {{ notificationData.GlobalId }}
          </div> 
        </div>
        <div class="item">
          <div class="title" style="font-weight: bold;">Note</div>  
          <div class="value truncate-text" style = "width:100%" [title]="appUtil.formatDateWithTimeUptoSec(notificationData.NoteDate)">
            {{ appUtil.formatDateWithTimeUptoSec(notificationData.NoteDate) }}
          </div>
            <div style="text-align: right; width: 100%;">
              <button one-icon-button mat-icon-button (click)="addNoteForm()">
                <i class="one-icons">edit</i>
              </button>
            </div>           
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card oneCard class="card-list-special" style="max-width:59.5%; width:100%;overflow: hidden;">
      <mat-card-title>
        <div class="mat-title">Status</div>
      </mat-card-title>
      <mat-card-content style="display: flex;">
        <mat-tab-group one-tab-group>
          <mat-tab label="Delivery">
            <div class="notification-chart" style="overflow: hidden;">
              <canvas #donutCustomer1>Chart</canvas>
            </div>
          </mat-tab>
        </mat-tab-group>
        <mat-tab-group *ngIf="feedbackEnabled" one-tab-group>
          <mat-tab label="Feedback">
            <div class="notification-chart" style="overflow: hidden;">
              <canvas #donutCustomer2>Chart</canvas>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>

  </div>

  <div style="display: block; margin-top:12px;">
    <mat-card oneCard class="card-list" style="width:100%">
      <mat-card-title>
        <div class="mat-title">Attachments</div>
      </mat-card-title>
      <mat-card-content style="display: block;">
        <ng-container *ngIf="notificationData.NotificationDocuments && notificationData.NotificationDocuments.length > 0 && notificationData.NotificationDocuments[0].PIMID && !isNoAttachmentsVisible()">
          <div class="nd-files-list" *ngFor="let attachment of notificationData.NotificationDocuments">
            <div class="single-file">
              <div class="info" (click)="downloadDocument(attachment.PIMID, attachment.FileExtension)">
                <mat-icon class="one-icons file-icon">{{ appUtil.formatFilesIcons(attachment.FileExtension) }}</mat-icon>
                <span class="name truncate-text" style="margin-left:20px" [title]="attachment.Title">
                  {{ attachment.Title }}
                </span>       
                <span class="globalTag">Global</span>
              </div>    
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="notificationData.NotificationAttachments && notificationData.NotificationAttachments.length > 0 && !isNoAttachmentsVisible()">
          <div class="nd-files-list" *ngFor="let attachmentData of notificationData.NotificationAttachments">
            <div class="single-file">
              <div class="info" (click)="downloadAttachment(attachmentData.FileName, notificationData.NotificationId)">
                <mat-icon class="one-icons file-icon">{{ appUtil.formatFilesIcons(attachmentData.FileName) }}</mat-icon>
                <span class="name truncate-text" style="margin-left:20px" [title]="attachmentData.FileName">
                  {{ attachmentData.FileName }}
                </span>   
                <span class="localTag">Local</span>
              </div>    
            </div>
          </div>
        </ng-container>

        <p *ngIf="isNoAttachmentsVisible()" style="color: red; font-style: italic; margin: 0;">
          No attachments added.
        </p>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Accounts Table -->
  <div class="notification-details-container" style="margin-top:12px;">

    <mat-card class="notification-recepient-list" style="box-shadow: none;">

      <div class="notification-header">

        <div class="notification-list-title">Accounts</div>

        <div class="notification-details-search">
          <dl-notification-search></dl-notification-search>
          <div title="Click to open filter Diaolg" class="notification-details-filter-icon" (click)="filterData()">
            <i class="one-icons filter-icon">filter</i>
            <span class="filter-text">Filter</span>
          </div>
        </div>

        <div style="text-align: right;" title="Click to configure columns">
          <i class="one-icons" [matMenuTriggerFor]="accountMenu" #accountMenuTrigger style="cursor: pointer;">settings</i>
        </div>

        <mat-menu #accountMenu="matMenu" class="columns-display-menu">
          <div xPosition="before" oneMenu>
            <mat-card class="one-card-flat" oneCard style="position:relative">

              <div class="column-header" (click)="$event.stopPropagation()">
                <div class="column-title">Show/Hide columns</div>
              </div>

              <one-table>
                <one-table-content (click)="$event.stopPropagation()">
                  <mat-table [dataSource]="accountDataSource" matTableExporter matSort multiTemplateDataRows #accountExporter="matTableExporter" class="configure-columns-table">
                    
                    <ng-container matColumnDef="select">
                      
                      <mat-header-cell *matHeaderCellDef>
                        <mat-checkbox 
                          (change)="$event ? masterToggleAccount($event) : null"
                          [checked]="accountSelection.hasValue() && isAllSelectedAccount($event)"
                          [indeterminate]="accountSelection.hasValue() && !isAllSelectedAccount($event)">
                        </mat-checkbox>
                      </mat-header-cell>

                      <mat-cell (click)="handleCheckedAccount(row)" *matCellDef="let row">
                        <mat-checkbox (change)="$event ? accountSelection.toggle(row) : null; AccountSelectedRow = row"
                          (click)="$event.stopPropagation()" [checked]="accountSelection.isSelected(row)" [disabled]="row.disabled">
                        </mat-checkbox>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="allColumns">
                      <mat-header-cell *matHeaderCellDef>All Columns</mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <div class="truncate-text">{{element.key}}</div>
                      </mat-cell>
                    </ng-container>
            
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-row 
                      *matRowDef="let row; columns: displayedColumns"
                      class="one-element-row"
                      [ngClass]="{ checked: accountSelection.isSelected(row), disabled: row.disabled }">
                    </mat-row>
                  </mat-table>
                </one-table-content>
            
                <one-table-footer class="table-footer">
                  <div>
                    <button color="primary" mat-flat-button (click)="getAccountSelectedColumns()">Apply</button>
                  </div>
                </one-table-footer>
              </one-table>
            </mat-card>
          </div>
        </mat-menu>

      </div>

    </mat-card>

    <dl-notification-accounts-table 
      [isSetCom]="isSetCom" 
      [notificationLabel]="notificationLabel"
      [contactDataDetails] = "contactDataObj"
      [contactDetails]="accountDataObj" 
      [notificationDetails]="notificationDataObj" 
      [selectedRecepientColumns]="accountSelectedColumns">
    </dl-notification-accounts-table>
  
  </div>
  
</div>
